import React, { InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  sizeClass?: string;
  fontClass?: string;
  rounded?: string;
  rightElement?: React.ReactNode; // ✅ NEW: for badge/icon slot
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className = "",
      sizeClass = "h-11 px-4 py-3",
      fontClass = "text-sm font-normal",
      rounded = "rounded-2xl",
      rightElement,
      ...args
    },
    ref
  ) => {
    return (
      <div className="relative">
        <input
          ref={ref}
          type={args.type || "text"}
          className={`block w-full pr-28 border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 ${rounded} ${fontClass} ${sizeClass} ${className}`}
          {...args}
        />
        {rightElement && (
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            {rightElement}
          </div>
        )}
      </div>
    );
  }
);

export default Input;
